import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoCircleRegular = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.75 10.5C16.3023 10.5 16.75 10.0523 16.75 9.5C16.75 8.94772 16.3023 8.5 15.75 8.5C15.1977 8.5 14.75 8.94772 14.75 9.5C14.75 10.0523 15.1977 10.5 15.75 10.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.75 14.5C16.75 14.0858 16.4142 13.75 16 13.75H14C13.5858 13.75 13.25 14.0858 13.25 14.5C13.25 14.9142 13.5858 15.25 14 15.25H15.25V22.25H13C12.5858 22.25 12.25 22.5858 12.25 23C12.25 23.4142 12.5858 23.75 13 23.75H19C19.4142 23.75 19.75 23.4142 19.75 23C19.75 22.5858 19.4142 22.25 19 22.25H16.75V14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 16C2.25 8.40608 8.40608 2.25 16 2.25C23.5939 2.25 29.75 8.40608 29.75 16C29.75 23.5939 23.5939 29.75 16 29.75C8.40608 29.75 2.25 23.5939 2.25 16ZM16 3.75C9.23451 3.75 3.75 9.23451 3.75 16C3.75 22.7655 9.23451 28.25 16 28.25C22.7655 28.25 28.25 22.7655 28.25 16C28.25 9.23451 22.7655 3.75 16 3.75Z",
			fill: "currentColor"
		})
	]
});
export default SvgInfoCircleRegular;
